module.exports = __webpack_public_path__ + "img/gb6178.prt.75abddff.jpg";